function handleScroll() {
  const body = document.body;
  if (window.scrollY === 0) {
    body.classList.add('topo');
    body.classList.remove('scrolled');
  } else {
    body.classList.remove('topo');
    body.classList.add('scrolled');
  }
}
window.addEventListener('scroll', handleScroll);
document.addEventListener('DOMContentLoaded', handleScroll);